import ICRank from "@/components/Icon/ICNavbar/ICRank";
import ICVault from "@/components/Icon/ICNavbar/ICVault.tsx";
import { ICWallet } from "@/components/Icon/ICProfile/ICWallet";
import { shortenAddress } from "@/utils/convert/format";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Logout from "@mui/icons-material/Logout";
import MenuIcon from "@mui/icons-material/Menu";
import Settings from "@mui/icons-material/Settings";
import { Divider } from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { usePrivy } from "@privy-io/react-auth";
import { useLocation, useRouter } from "@tanstack/react-router";
import * as React from "react";
import { useTranslation } from "react-i18next";
import LoginButton from "../../LoginButton/LoginButton";

const MOBILE_MENU_ITEMS = [
  {
    key: "navbar.vault",
    path: "/vault",
    icon: <ICVault width="24" height="24" />,
    private: false,
  },
  {
    key: "navbar.ranks",
    path: "/ranking",
    icon: <ICRank width="24" height="24" />,
    private: false,
  },
  {
    key: "navbar.menu.profile",
    path: "/user-profile",
    icon: <AccountCircleIcon width="24" height="24" />,
    private: true,
  },
  {
    key: "navbar.menu.settings",
    path: "",
    icon: <Settings width="24" height="24" />,
    private: true,
  },

  {
    key: "navbar.menu.logout",
    path: "",
    icon: <Logout width="24" height="24" />,
    private: true,
  },
];

export default function MobileNavigation() {
  const { t } = useTranslation();
  const router = useRouter();
  const location = useLocation();
  const { user, authenticated, logout } = usePrivy();

  const isVerifyPage =
    location.pathname === "/verify" || location.pathname === "/not-found";
  const walletAddress = user?.wallet?.address || "";

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleNavigation = (key: string, path: string) => {
    if (key === "navbar.menu.logout") {
      logout();
      handleClose();
      return;
    }

    if (key === "navbar.menu.settings") {
      handleClose();
      return;
    }

    handleClose();
    router.navigate({ to: path });
  };

  return (
    <div>
      <Button
        variant="text"
        id="demo-positioned-button"
        aria-controls={open ? "demo-positioned-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        sx={{
          color: "white",
          "&:hover": {
            color: "white",
            backgroundColor: "transparent",
          },
          padding: 0,
        }}
      >
        <MenuIcon />
      </Button>
      <Menu
        id="demo-positioned-menu"
        aria-labelledby="demo-positioned-button"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
        sx={{
          marginTop: "12px",
        }}
      >
        {authenticated && (
          <>
            <div className="px-4 pt-1 pb-3 flex items-center gap-2">
              <ICWallet width="16" height="16" />
              <p className="text-sm">{shortenAddress(walletAddress, 6, 4)}</p>
            </div>
            <Divider />
          </>
        )}
        {MOBILE_MENU_ITEMS.map((item) => {
          if (item.private && !authenticated) return null;

          return (
            <MenuItem
              key={item.key}
              onClick={() => handleNavigation(item.key, item.path)}
              disabled={isVerifyPage}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                opacity: isVerifyPage ? 0.5 : 1,
                color:
                  location.pathname === item.path
                    ? "var(--brand-primary-green)"
                    : "white",
              }}
            >
              {item.icon}
              {t(item.key)}
            </MenuItem>
          );
        })}

        {!authenticated && (
          <MenuItem sx={{ justifyContent: "center" }}>
            <LoginButton />
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
